export enum UserFlagIdentifierType {
  GET_SOCIAL_INTRO_SEEN = 'GET_SOCIAL_INTRO_SEEN',
  DIET_WARNING_SEEN = 'DIET_WARNING_SEEN',
  INSULIN_CALCULATOR_INTRO_SEEN = 'INSULIN_CALCULATOR_INTRO_SEEN',
  DIET_PLAN_INTRO_SEEN = 'DIET_PLAN_INTRO_SEEN',
}

export type SetUserFlag = (identifier: UserFlagIdentifierType) => any;
